import { pubsub } from './pubsub';

// adds a task passing in the project index
export function processAddTaskButton() {
	pubsub.subscribe('taskButtonAdded', addTask)
}

function addTask(index) {
	const addTaskButton = document.querySelector('.add-task-button');
	addTaskButton.addEventListener('click', (event) => {
		const taskModal = document.createElement('dialog');
		taskModal.classList.add('task-dialog-element');
		taskModal.dataset.taskDialogElement = true;

		// creating the form element
		const taskForm = document.createElement('form');
		taskForm.classList.add('add-task-form');

		// task title input
		// label
		const taskNameLabel = document.createElement('label');
		taskNameLabel.textContent = 'Name: ';
		taskNameLabel.classList.add('task-name-label');
		// input
		const taskNameInput = document.createElement('input');
		taskNameInput.type = 'text';
		taskNameInput.dataset.taskNameInput = true;
		taskNameInput.required = true;
		taskNameInput.maxLength = 80;
		// apending elements
		taskNameLabel.appendChild(taskNameInput);

		// task details input
		// label
		const taskDetailsLabel = document.createElement('label');
		taskDetailsLabel.textContent = 'Details: ';
		taskDetailsLabel.classList.add('task-details-label');
		// input
		const taskDetailsInput = document.createElement('textarea');
		taskDetailsInput.dataset.taskDetailsInput = true;
		taskDetailsInput.maxLength = 500;
		// appending elements
		taskDetailsLabel.appendChild(taskDetailsInput);

		// task due date input
		// label
		const dueDateLabel = document.createElement('label');
		dueDateLabel.textContent = 'Due Date: ';
		dueDateLabel.classList.add('due-date-label');
		// input
		const dueDateInput = document.createElement('input');
		dueDateInput.type = 'date';
		dueDateInput.dataset.dueDateInput = true;
		dueDateInput.required = true;
		// appending input to label
		dueDateLabel.appendChild(dueDateInput);

		// priority input
		// fieldset
		const taskPriorityFieldset = document.createElement('fieldset');
		const fieldsetLabel = document.createElement('label');
		fieldsetLabel.textContent = 'Priority: ';
		taskPriorityFieldset.appendChild(fieldsetLabel);

		// hig-priority label
		const highPriorityLabel = document.createElement('label');
		highPriorityLabel.textContent = 'High';
		// input
		const highPriorityInput = document.createElement('input');
		highPriorityInput.type = 'radio';
		highPriorityInput.dataset.highPriorityInput = 'true';
		highPriorityInput.name = 'priority';
		highPriorityInput.value = '3';
		// appending input to label
		highPriorityLabel.appendChild(highPriorityInput);

		// medium-priority label
		const mediumPriorityLabel = document.createElement('label');
		mediumPriorityLabel.textContent = 'Medium';
		// input
		const mediumPriorityInput = document.createElement('input');
		mediumPriorityInput.type = 'radio';
		mediumPriorityInput.dataset.mediumPriorityInput = 'true';
		mediumPriorityInput.name = 'priority';
		mediumPriorityInput.value = '2';
		// appending input to label
		mediumPriorityLabel.appendChild(mediumPriorityInput);

		// low-priority label
		const lowPriorityLabel = document.createElement('label');
		lowPriorityLabel.textContent = 'Low';
		// input
		const lowPriorityInput = document.createElement('input');
		lowPriorityInput.type = 'radio';
		lowPriorityInput.dataset.lowPriorityInput = 'true';
		lowPriorityInput.checked = 'true';
		lowPriorityInput.name = 'priority';
		lowPriorityInput.value = '1';
		// appending input to label
		lowPriorityLabel.appendChild(lowPriorityInput);

		// appending radio buttons to fieldset
		taskPriorityFieldset.append(highPriorityLabel, mediumPriorityLabel, lowPriorityLabel);

		// task completed input
		// label
		const taskCompletedLabel = document.createElement('label');
		taskCompletedLabel.textContent = 'Task Completed: ';
		// input
		const taskCompletedInput = document.createElement('input');
		taskCompletedInput.type = 'checkbox';
		// appending input to label
		taskCompletedLabel.appendChild(taskCompletedInput);

		// submit, edit, and cancel buttons
		const buttonContainer = document.createElement('div');
		buttonContainer.classList.add('button-container');
		// sumit button
		const submitButton = document.createElement('button');
		submitButton.type = 'submit';
		submitButton.textContent = 'Add Task';
		submitButton.classList.add('submit-button');

		// Cancel button
		const cancelButton = document.createElement('button');
		cancelButton.type = 'button';
		cancelButton.textContent = 'Cancel';
		cancelButton.classList.add('cancel-button');
		cancelButton.dataset.closeInputForm = true;
		// appending buttons to button
		buttonContainer.append(submitButton, cancelButton);
		// add event listener to cancelButton
		cancelButton.addEventListener('click', closeInputModal);

		// appending elements to form and the form to modal
		taskForm.append(taskNameLabel, taskDetailsLabel, dueDateLabel, taskPriorityFieldset, taskCompletedLabel, buttonContainer);
		taskModal.appendChild(taskForm);

		// append modal to body and show on click
		document.body.appendChild(taskModal);
		taskModal.showModal();

		// submitting the form info
		taskForm.addEventListener('submit', (event) => {
			event.preventDefault();
			const projectIndex = index;
			const taskName = taskNameInput.value;
			const taskDetails = taskDetailsInput.value;
			const taskDate = dueDateInput.value;
			const taskPriority = document.querySelector('input[name="priority"]:checked').value;
			const taskCompleted = taskCompletedInput.checked;
			const taskInfo = {
				index: projectIndex,
				name: taskName,
				details: taskDetails,
				date: taskDate,
				priority: taskPriority,
				completed: taskCompleted
			}
			pubsub.publish('taskAdded', taskInfo);
			taskForm.reset();
			taskModal.close();
			taskModal.remove();
		});
	});
}

// part of the flow for editing a task
export function processTaskInfoForEditModal() {
	pubsub.subscribe('taskInfoForEditModal', openEditModal);
}

function openEditModal(object) {
	const taskModal = document.createElement('dialog');
	taskModal.classList.add('task-dialog-element');
	taskModal.dataset.taskEditModal = true;

	// creating the form element
	const taskForm = document.createElement('form');
	taskForm.classList.add('add-task-form');

	// task title input
	// label
	const taskNameLabel = document.createElement('label');
	taskNameLabel.textContent = 'Name: ';
	taskNameLabel.classList.add('task-name-label');
	// input
	const taskNameInput = document.createElement('input');
	taskNameInput.type = 'text';
	taskNameInput.dataset.taskNameInput = true;
	taskNameInput.required = true;
	// populating input with object data
	taskNameInput.value = object.name;
	// apending elements
	taskNameLabel.appendChild(taskNameInput);

	// task details input
	// label
	const taskDetailsLabel = document.createElement('label');
	taskDetailsLabel.textContent = 'Details: ';
	taskDetailsLabel.classList.add('task-details-label');
	// input
	const taskDetailsInput = document.createElement('textarea');
	taskDetailsInput.dataset.taskDetailsInput = true;
	// populating input with object data
	taskDetailsInput.value = object.description;
	// appending elements
	taskDetailsLabel.appendChild(taskDetailsInput);

	// task due date input
	// label
	const dueDateLabel = document.createElement('label');
	dueDateLabel.textContent = 'Due Date: ';
	dueDateLabel.classList.add('due-date-label');
	// input
	const dueDateInput = document.createElement('input');
	dueDateInput.type = 'date';
	dueDateInput.dataset.dueDateInput = true;
	dueDateInput.required = true;
	// populating input with object data
	dueDateInput.value = object.date;
	// appending input to label
	dueDateLabel.appendChild(dueDateInput);

	// priority input
	// fieldset
	const taskPriorityFieldset = document.createElement('fieldset');
	const fieldsetLabel = document.createElement('label');
	fieldsetLabel.textContent = 'Priority: ';
	taskPriorityFieldset.appendChild(fieldsetLabel);

	// hig-priority label
	const highPriorityLabel = document.createElement('label');
	highPriorityLabel.textContent = 'High';
	// input
	const highPriorityInput = document.createElement('input');
	highPriorityInput.type = 'radio';
	highPriorityInput.dataset.highPriorityInput = 'true';
	highPriorityInput.name = 'priority';
	highPriorityInput.value = '3';
	// appending input to label
	highPriorityLabel.appendChild(highPriorityInput);

	// medium-priority label
	const mediumPriorityLabel = document.createElement('label');
	mediumPriorityLabel.textContent = 'Medium';
	// input
	const mediumPriorityInput = document.createElement('input');
	mediumPriorityInput.type = 'radio';
	mediumPriorityInput.dataset.mediumPriorityInput = 'true';
	mediumPriorityInput.name = 'priority';
	mediumPriorityInput.value = '2';
	// appending input to label
	mediumPriorityLabel.appendChild(mediumPriorityInput);

	// low-priority label
	const lowPriorityLabel = document.createElement('label');
	lowPriorityLabel.textContent = 'Low';
	// input
	const lowPriorityInput = document.createElement('input');
	lowPriorityInput.type = 'radio';
	lowPriorityInput.dataset.lowPriorityInput = 'true';
	lowPriorityInput.name = 'priority';
	lowPriorityInput.value = '1';
	// populating input with object data
	switch(object.priority) {
		case '3':
			highPriorityInput.checked = true;
			break;
		case '2':
			mediumPriorityInput.checked = true;
			break;
		case '1':
			lowPriorityInput.checked = true;
			break;
	}
	// appending input to label
	lowPriorityLabel.appendChild(lowPriorityInput);

	// appending radio buttons to fieldset
	taskPriorityFieldset.append(highPriorityLabel, mediumPriorityLabel, lowPriorityLabel);

	// task completed input
	// label
	const taskCompletedLabel = document.createElement('label');
	taskCompletedLabel.textContent = 'Task Completed: ';
	// input
	const taskCompletedInput = document.createElement('input');
	taskCompletedInput.type = 'checkbox';
	// populating input with object data
	switch(object.done) {
		case true:
			taskCompletedInput.checked = true;
			break;
		case false:
			taskCompletedInput.checked = false;
			break;
	}
	// appending input to label
	taskCompletedLabel.appendChild(taskCompletedInput);

	// submit, edit, and cancel buttons
	const buttonContainer = document.createElement('div');
	buttonContainer.classList.add('button-container');

	// Edit button
	const editButton = document.createElement('button');
	editButton.type = 'submit';
	editButton.textContent = 'Edit Task';
	editButton.classList.add('edit-button');
	// Cancel button
	const cancelButton = document.createElement('button');
	cancelButton.type = 'button';
	cancelButton.textContent = 'Cancel';
	cancelButton.classList.add('cancel-button');
	// appending buttons to button
	buttonContainer.append(editButton, cancelButton);
	// add event listener to cancel button
	cancelButton.addEventListener('click', closeTakEditModal);

	// appending elements to form and the form to modal
	taskForm.append(taskNameLabel, taskDetailsLabel, dueDateLabel, taskPriorityFieldset, taskCompletedLabel, buttonContainer);
	taskModal.appendChild(taskForm);

	// append modal to body and show on click
	document.body.appendChild(taskModal);
	taskModal.showModal();

	// submitting the form info
	taskForm.addEventListener('submit', (event) => {
		event.preventDefault();
		const taskIndex = object.taskId;
		const projectIndex = object.projectId;
		const taskName = taskNameInput.value;
		const taskDetails = taskDetailsInput.value;
		const taskDate = dueDateInput.value;
		const taskPriority = document.querySelector('input[name="priority"]:checked').value;
		const taskCompleted = taskCompletedInput.checked;
		const taskInfo = {
			taskId: taskIndex,
			title: taskName,
			description: taskDetails,
			duedate: taskDate,
			priority: taskPriority,
			done: taskCompleted,
			projectId: projectIndex,
		}
		pubsub.publish('taskEdited', taskInfo);
		//taskForm.reset();
		taskModal.close();
		taskModal.remove();
	});
}

// function to close the modal that adds a task
function closeInputModal() {
	//event.preventDefault();
	const inputModal = document.querySelector('[data-task-dialog-element]');
	inputModal.close();
	// remove the dialog element from the DOM
	// if not, the close() function just hides it and
	// it won't close a second time
	inputModal.remove();
}

// function to close the modal that edits a task
function closeTakEditModal() {
	const inputEditModal = document.querySelector('[data-task-edit-modal]');
	// close the modal
	inputEditModal.close();
	// remove the modal from the DOM
	inputEditModal.remove();
}
